import type { MarketplaceLineSnapshot } from "@loot-os/fulfillment-core/order/marketplace-line";

/**
 * The buy facts out of an order line's tenant-sent snapshot, for display.
 * Unlike the core's parser this drops a mistyped field instead of throwing:
 * one bad key must not blank the page a fulfiller reads the rest of the buy from.
 */
export function readMarketplaceSnapshot(snapshot: unknown): MarketplaceLineSnapshot {
  if (typeof snapshot !== "object" || snapshot === null || Array.isArray(snapshot)) return {};
  const fields = snapshot as Record<string, unknown>;
  // Either spelling of the price basis: a box-drop line carries the suffixed one.
  const priceBasis = fields.listingPriceCents ?? fields.listingPrice;
  return {
    listingPrice:
      typeof priceBasis === "number" && Number.isFinite(priceBasis) ? priceBasis : undefined,
    variantId: typeof fields.variantId === "string" ? fields.variantId : undefined,
    variantValue: typeof fields.variantValue === "string" ? fields.variantValue : undefined,
    productUrl: typeof fields.productUrl === "string" ? fields.productUrl : undefined,
    chargedPriceCents: finiteNumberOrUndefined(fields.chargedPriceCents),
    chargedUsShippingCents: finiteNumberOrUndefined(fields.chargedUsShippingCents),
    chargedShippingSurchargeCents: finiteNumberOrUndefined(fields.chargedShippingSurchargeCents),
  };
}

function finiteNumberOrUndefined(value: unknown): number | undefined {
  return typeof value === "number" && Number.isFinite(value) ? value : undefined;
}
